import React, { createContext, useContext, useEffect, useState, useSyncExternalStore } from "react";
import { LANGS, STRINGS } from "../lib/i18n";
import UI from "../lib/uiTranslations.json";
import { contentTranslation, subscribeTranslations, translationSnapshot, translationStatus, retryTranslations } from "../lib/contentTranslations";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, updateLang] = useState(() => {
    const stored = localStorage.getItem("js_lang");
    return LANGS.some(l => l.code === stored) ? stored : "en";
  });
  const setLang = code => { if (LANGS.some(l => l.code === code)) updateLang(code); };
  useSyncExternalStore(subscribeTranslations, translationSnapshot);
  useEffect(() => {
    localStorage.setItem("js_lang", lang);
    document.documentElement.lang = lang;
    document.title = STRINGS[lang].org;
  }, [lang]);
  const tx = (text, values = {}) => {
    if (typeof text !== "string") return text;
    const translated = UI[lang]?.[text.trim()] || text;
    return translated.replace(/\{([^{}]+)\}/g, (match, key) => values[key] ?? match);
  };
  const ct = text => {
    if (typeof text !== "string" || !text.trim()) return text;
    return UI[lang]?.[text.trim()] || contentTranslation(text, lang);
  };
  const t = (path) => {
    const parts = path.split(".");
    let v = STRINGS[lang] || STRINGS.en;
    for (const p of parts) v = v?.[p];
    if (v === undefined) {
      let f = STRINGS.en;
      for (const p of parts) f = f?.[p];
      return f ?? path;
    }
    return v;
  };
  return (
    <I18nCtx.Provider value={{ lang, setLang, langs: LANGS, t, tx, ct, translation: translationStatus(lang), retryTranslation: () => retryTranslations(lang) }}>{children}</I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
